export const AI_BOT_USER_ID = -1
export const AI_BOT_USER_NAME = 'Aivard'
export const AI_BOT_TYPING_TEXT = 'Thinking'
export const AI_TYPING_MESSAGE = 'Thinking...'